module.exports = __webpack_public_path__ + "src/assets/img/page8/4489e9d96edb600913a21b85e5f5f129.jpg";